import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { SetAvailabilityPayload, TimetableDayDetail, TimetableWeek } from '@/types/timetable';

/**
 * Every call the timetable screens make.
 *
 * All three are the caller's own week — the server resolves which slots are
 * theirs from their allotments, so none of these paths carries a teacher id.
 */
export const timetableApi = {
  /** A week of the caller's own periods. Any day in it identifies the week. */
  week: (weekOf?: string) =>
    unwrap(
      apiClient.get<ApiSuccess<TimetableWeek>>('/institute/timetable/me', {
        params: weekOf ? { weekOf } : undefined,
      }),
    ),

  /** One day of it. Omitting the date means today, decided in IST by the server. */
  day: (date?: string) =>
    unwrap(
      apiClient.get<ApiSuccess<TimetableDayDetail>>('/institute/timetable/me/day', {
        params: date ? { date } : undefined,
      }),
    ),

  /**
   * "I cannot take this period on this date", or taking that back.
   *
   * Returns the whole day, so the screen never has to guess what the counts
   * became.
   */
  setAvailability: (entryUuid: string, payload: SetAvailabilityPayload) =>
    unwrap(
      apiClient.put<ApiSuccess<TimetableDayDetail>>(
        `/institute/timetable/entries/${entryUuid}/availability`,
        payload,
      ),
    ),
};
